import { render, staticRenderFns } from "./IntelligencePatientFrictionKpiCards.vue?vue&type=template&id=5fd4943e&scoped=true"
import script from "./IntelligencePatientFrictionKpiCards.vue?vue&type=script&lang=js"
export * from "./IntelligencePatientFrictionKpiCards.vue?vue&type=script&lang=js"
import style0 from "./IntelligencePatientFrictionKpiCards.vue?vue&type=style&index=0&id=5fd4943e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd4943e",
  null
  
)

export default component.exports